import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { LiquidacionService } from 'app/services/liquidacion/liquidacion.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-detalle-liquidaciones',
  templateUrl: './detalle-liquidaciones.component.html',
  styleUrls: ['./detalle-liquidaciones.component.scss']
})
export class DetalleLiquidacionesComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  dataDetalle: any = this.liquidacionService.detalleLiquidacion;
  dataDoc:any = [];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() cerrarDetalle = new EventEmitter<boolean>();
  pageSizeOptions = [10,20,30,50,100,200];
  displayedColumns: string[] =   
  ['Fecha_Desembolso','TEM','Porcentaje','idSolicitudD_Detalle','Adelanto_Importe','Desembolso_Importe','Interes_Proveedor','Interes_Proveedor_Real','Interes_Proveedor_Diferencia','Interes_Adquirente','Interes_Adquirente_Real','Interes_Adquirente_Diferencia'];
  dataSource:any;
  loading : boolean;
  detalle:any=[];
  constructor(private liquidacionService: LiquidacionService) { }

  InteresProvDiferencial:any = 0;
  InteresAdqDiferencial:any = 0;
  AdelantoImporteTotal:any = 0;
  DocNegociable : any;

  ngOnInit() {
    this.listadoDetalle();
  }

  listadoDetalle(){
    this.loading = true;
    this.liquidacionService.obtenerLiquidacionesDetalle(this.dataDetalle.idLiquidacion).subscribe(
      res=>{
        this.detalle = res;
        this.dataDoc = this.detalle.document;
        this.DocNegociable = this.dataDoc.Serie + ' - ' +this.dataDoc.Numero;
        this.detalle.detail.forEach(element => {
          this.InteresProvDiferencial += Number(element.Interes_Proveedor_Diferencia);
          this.InteresAdqDiferencial += Number(element.Interes_Adquirente_Diferencia);
          this.AdelantoImporteTotal += Number(element.Adelanto_Importe);
        });        
          this.dataSource = new MatTableDataSource( this.detalle.detail);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
      }
    )
  }

  CerrarPopUp(){
    this.liquidacionService.detalleLiquidacion =[];
    this.cerrarDetalle.emit();
  }
}

